export enum RegistrationSource {
  PR = 'photoregister',
  QR = 'qrcode',
  WEB = 'web',
}
